import React from 'react';
import GenericAccordion from 'components/GenericAccordion';
import LayersGroup from 'components/LayersGroup';
import { useSelector } from 'react-redux';
import { color } from 'styles/Theme';
import * as S from './styled';
import Deforestation from './Deforestation';
import Burned from './Burned';

export default function HumanOcupation() {
	const { checkRadios } = useSelector((state) => state.threatsTis);
	const { allLayers } = useSelector((state) => state.allLayersMap);

	const { desmatamento, fogo } = checkRadios || {};

	const key = 'ameacas';
	const { name } = allLayers?.find((item) => item.key === key);

	return (
		<GenericAccordion
			title={name?.toUpperCase() || 'Sem nome'}
			keyAccordion={key}
			styleTitle={{
				color: `${color.interface.darkGray}`,
				fontFamily: 'Nunito',
				fontStyle: 'normal',
				fontWeight: '800',
				lineHeight: '0.875rem',
				fontSize: '0.625rem',
				letterSpacing: '0.1em',
				textTransform: 'uppercase'
			}}
		>
			<S.containerAccordionInside>
				<LayersGroup layerGroup={key} useToggle={false} showTitle={false} />

				{desmatamento === true && <Deforestation />}

				{fogo === true && <Burned />}
			</S.containerAccordionInside>
		</GenericAccordion>
	);
}
